import { Observable } from 'rxjs';
import { LocationDetailsResponse } from '../models/location-details.model';

export abstract class LocationDetailsRepository {
    abstract getLocationDetails(
        id: string,
    ): Observable<LocationDetailsResponse>;
}
